import React, { useState, useMemo, useEffect } from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/webpack-resolver';
import 'ace-builds/src-noconflict/mode-yaml';
import 'ace-builds/src-noconflict/theme-github';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import YAML from 'yaml';
const ExpertEditorWidget = ({ value, onChange, readonly, disabled, schema, height }) => {
    const { t } = useTranslation();
    const [error, setError] = useState(null);
    const [text, setText] = useState('');
    const [isEdited, setIsEdited] = useState(false);
    const prefillText = useMemo(() => {
        const valueIsEmpty = value === undefined || value === null || (typeof value === 'object' && value !== null && Object.keys(value).length === 0);
        let requiredFields;
        if (schema.required) {
            requiredFields = schema.required;
        }
        else if (schema.oneOf && Array.isArray(schema.oneOf) && schema.oneOf.length > 0) {
            const firstSubSchema = schema.oneOf[0];
            if (typeof firstSubSchema === 'object' && firstSubSchema.required) {
                requiredFields = firstSubSchema.required;
            }
        }
        if (requiredFields && valueIsEmpty) {
            const prefillObject = requiredFields.reduce((acc, field) => {
                acc[field] = '...';
                return acc;
            }, {});
            try {
                return YAML.stringify(prefillObject);
            }
            catch (e) {
                return '';
            }
        }
        return '';
    }, [schema, value]);
    useEffect(() => {
        if (!isEdited && prefillText) {
            setText(prefillText);
        }
    }, [isEdited, prefillText]);
    const initialValue = useMemo(() => {
        const valueIsEmpty = value === undefined || value === null || (typeof value === 'object' && value !== null && Object.keys(value).length === 0);
        if (valueIsEmpty) {
            return isEdited ? '' : prefillText;
        }
        try {
            return YAML.stringify(value);
        }
        catch (e) {
            try {
                // Fallback for values that can't be stringified to YAML but are valid objects
                return JSON.stringify(value, null, 2);
            }
            catch (jsonError) {
                return '';
            }
        }
    }, [value, isEdited, prefillText]);
    useEffect(() => {
        // Update text only if it's not currently being edited, to avoid cursor jumps
        if (!isEdited) {
            setText(initialValue);
        }
    }, [initialValue, isEdited]);
    const handleEditorChange = (newValue) => {
        if (!isEdited) {
            setIsEdited(true);
        }
        setText(newValue);
        if (newValue.trim() === '') {
            onChange(undefined);
            setError(null);
            return;
        }
        try {
            const parsed = YAML.parse(newValue);
            onChange(parsed);
            setError(null);
        }
        catch (e) {
            onChange(undefined); // Let RJSF know the value is invalid
            setError(t('invalidYamlFormat', 'Invalid YAML format'));
        }
    };
    return (React.createElement("div", null,
        React.createElement(AceEditor, { mode: "yaml", theme: "github", value: text, onChange: handleEditorChange, name: "expert-editor-widget", width: "100%", height: height || '150px', fontSize: 14, readOnly: readonly, editorProps: { $blockScrolling: true }, setOptions: { useWorker: false } }),
        error && React.createElement(Alert, { message: error, type: "error", showIcon: true, style: { marginTop: '8px' } })));
};
export default ExpertEditorWidget;
